/* logo laod
document.addEventListener("DOMContentLoaded", function() {
  var spinner = document.getElementById('loader');
  spinner.style.display = 'block';

  window.addEventListener('loader', function() {
    spinner.style.display = 'none';
  });
});
*/



/* open external links in new tab */
/*
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }}
*/


// only show one collapsible text box at a time
/*
document.addEventListener('DOMContentLoaded', function() {
  const accordionGroup = document.querySelector('.product-info__block-group');

  if (accordionGroup) {
    const accordions = accordionGroup.querySelectorAll('details.accordion');

    accordions.forEach(accordion => {
      const summary = accordion.querySelector('summary');
      const content = accordion.querySelector('.accordion__content');

      summary.addEventListener('click', () => {
        accordions.forEach(otherAccordion => {
          const otherContent = otherAccordion.querySelector('.accordion__content');
          if (otherAccordion !== accordion && otherContent.style.opacity === '1') {
            otherContent.style.opacity = '0';
            otherAccordion.setAttribute('aria-expanded', 'false');
          }
        });

        if (content.style.opacity === '0') {
          content.style.opacity = '1';
          accordion.setAttribute('aria-expanded', 'true');
        } else {
          content.style.opacity = '0';
          accordion.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
});
*/

/* WORKS but have to press 2 or 3 times first
window.addEventListener('load', function() {
  setTimeout(function() {
    const accordionGroup = document.querySelector('.product-info__block-group');

    if (accordionGroup) {
      const accordions = accordionGroup.querySelectorAll('details.accordion');

      accordions.forEach(accordion => {
        const summary = accordion.querySelector('summary');
        const content = accordion.querySelector('.accordion__content');

        summary.addEventListener('click', () => {
          accordions.forEach(otherAccordion => {
            const otherContent = otherAccordion.querySelector('.accordion__content');
            if (otherAccordion !== accordion && otherContent.style.opacity === '1') {
              otherContent.style.opacity = '0';
              otherAccordion.setAttribute('aria-expanded', 'false');
            }
          });

          if (content.style.opacity === '0') {
            content.style.opacity = '1';
            accordion.setAttribute('aria-expanded', 'true');
          } else {
            content.style.opacity = '0';
            accordion.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  }, 100); // Delay of 100 milliseconds
});
*/






/* latest but not working 
window.addEventListener('load', function() {
  function initAccordions() {
    const accordionGroup = document.querySelector('.product-info__block-group');

    if (accordionGroup) {
      const accordions = accordionGroup.querySelectorAll('details.accordion');

      accordions.forEach(accordion => {
        const summary = accordion.querySelector('summary');
        const content = accordion.querySelector('.accordion__content');
        const animatedPlus = summary.querySelector('.animated-plus');

        summary.addEventListener('click', (event) => {
          event.preventDefault(); // Prevent the default behavior of the <details> element

          const isOpen = accordion.hasAttribute('open');

          accordions.forEach(otherAccordion => {
            const otherContent = otherAccordion.querySelector('.accordion__content');
            if (otherAccordion !== accordion && otherContent.style.opacity === '1') {
              otherAccordion.removeAttribute('open');
              otherContent.style.opacity = '0';
              otherAccordion.setAttribute('aria-expanded', 'false');
            }
          });

          if (isOpen) {
            accordion.removeAttribute('open');
            content.style.opacity = '0';
            accordion.setAttribute('aria-expanded', 'false');
            animatedPlus.classList.remove('group-expanded:rotate');
          } else {
            accordion.setAttribute('open', '');
            content.style.opacity = '1';
            accordion.setAttribute('aria-expanded', 'true');
            animatedPlus.classList.add('group-expanded:rotate');
          }
        });
      });
    }
  }

  // Check if the accordion elements are loaded every 100ms
  const intervalId = setInterval(function() {
    const accordionGroup = document.querySelector('.product-info__block-group');
    if (accordionGroup && accordionGroup.querySelectorAll('details.accordion').length > 0) {
      clearInterval(intervalId);
      initAccordions();
    }
  }, 100);
});
*/



document.addEventListener('DOMContentLoaded', function() {
    // Wait for the popup to load
    const emailInput = document.querySelector('.newsletter-popup input[type="email"]');
    
    if (emailInput) {
        emailInput.placeholder = 'you@email.com';
    }
});











/**
 * Generate the part of the sequence when the given slide is entering
 */
getSlideEnteringSequence_fn = function(slide) {
  const slideContent = slide.querySelector(".slideshow__slide-content");
  if (slideContent.classList.contains("slideshow__slide-content--boxed")) {
    return [
      [slide, { opacity: [0, 1] }, { duration: 0, easing: [] }],  // No duration/easing for opacity
      [slide.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), { opacity: [0, 1], transform: ["scale(1.2)", "scale(1)"] }, { duration: 0, at: "<", easing: [] }],
      [slideContent, { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.6, at: "-0.4", easing: [0.215, 0.61, 0.355, 1] }]
    ];
  } else {
    return [
      [slide, { opacity: [0, 1] }, { duration: 0, easing: [] }],  // No duration/easing for opacity
      [slide.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), { opacity: [0, 1], transform: ["scale(1.2)", "scale(1)"] }, { duration: 0, at: "<", easing: [] }],
      [slideContent.querySelector(".prose"), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0, easing: [] }],  // No duration/easing for opacity
      [slideContent.querySelector(".button-group"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0, easing: [] }]  // No duration/easing for opacity
    ];
  }
};

/**
 * Generate the part of the sequence when the given slide is leaving
 */
getSlideLeavingSequence_fn = function(slide) {
  const slideContent = slide.querySelector(".slideshow__slide-content");
  if (slideContent.classList.contains("slideshow__slide-content--boxed")) {
    return [
      [slideContent, { opacity: [1, 0], transform: ["translateY(0)", "translateY(20px)"] }, { duration: 0, at: "leaving", easing: [] }],  // No duration/easing for opacity
      [slide.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), { opacity: [1, 0] }, { duration: 0, at: "-0.1", easing: [] }]
    ];
  } else {
    return [
      [slideContent.querySelector(".prose"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(10px)"] }, { duration: 0, at: "leaving", easing: [] }],  // No duration/easing for opacity
      [slideContent.querySelector(".button-group"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(20px)"] }, { duration: 0, at: "<", easing: [] }],
      [slide.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), { opacity: [1, 0] }, { duration: 0, at: "-0.1", easing: [] }]
    ];
  }
};








/* SMALL GRID COLLECTION ANIMATION */
/*
  document.addEventListener("DOMContentLoaded", function() {
    const productCards = document.querySelectorAll('.collection .product-list[collection-desktop-layout="compact"] .product-card');

    productCards.forEach(card => {
        const randomYMovement = Math.random() * 16 - 8;  // Random vertical movement between -8px and 8px
        const randomDuration = Math.random() * 2 + 4;   // Random duration between 4s and 6s
        let startTime = null;

        function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = (timestamp - startTime) / (randomDuration * 1000); // Normalize time
            const translateY = Math.sin(progress * Math.PI * 2) * randomYMovement;  // Sine wave vertical movement

            // Apply the transform to the card
            card.style.transform = `translateY(${translateY}px)`;

            if (progress < 1) {
                requestAnimationFrame(animate); // Continue animating
            } else {
                startTime = timestamp; // Reset the start time to loop the animation
                requestAnimationFrame(animate); // Restart the animation loop
            }
        }

        requestAnimationFrame(animate); // Start the animation loop for each card
    });
});
*/







/* accordian - open one at a time */
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.accordion__disclosure details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('click', function() {
      // Close all other accordions
      accordions.forEach((item) => {
        if (item !== accordion && item.open) {
          item.removeAttribute('open');
        }
      });
    });
  });
});












/* 1-9 QUANTITY SELECTOR PRODUCT PAGE */
/*
document.addEventListener('DOMContentLoaded', () => {
  const quantityOptions = document.querySelectorAll('.quantity-selector__option');
  const quantityInput = document.getElementById('quantity-input');

  if (quantityOptions) {
    quantityOptions.forEach(option => {
      option.addEventListener('click', () => {
        // Remove active class from all buttons
        quantityOptions.forEach(opt => opt.classList.remove('active'));

        // Add active class to the clicked button
        option.classList.add('active');

        // Update the hidden input value
        quantityInput.value = option.dataset.value;
      });
    });
  }
});
*/





/* randomize the order of announcement bar messages */
document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.announcement-bar__carousel');
  if (!carousel) return;

  const messages = Array.from(carousel.querySelectorAll('p'));
  if (messages.length <= 1) return;

  // Remove all messages from DOM
  messages.forEach(p => p.remove());

  // Shuffle them
  const shuffled = messages.sort(() => Math.random() - 0.5);

  // Re-append in random order
  shuffled.forEach((p, i) => {
    p.classList.toggle('is-selected', i === 0); // Ensure one is marked selected
    carousel.appendChild(p);
  });
});


/* FLASHES 'welcome' */
/*
document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.announcement-bar__carousel');
  if (!carousel) return;

  const messages = Array.from(carousel.querySelectorAll('p'));
  if (messages.length <= 1) return;

  const shuffled = shuffle(messages);

  // Remove all messages from DOM
  messages.forEach(p => p.remove());

  // Re-append all in shuffled order
  shuffled.forEach(p => carousel.appendChild(p));

  function shuffle(array) {
    return array.sort(() => Math.random() - 0.5);
  }
});
*/









